import React from "react";

function formatPrice(price) {
  if (!price) return "";
  const amount = Number(price.amount || 0);
  const currency = String(price.currency || "USD").toUpperCase();
  const formattedAmount = Number.isInteger(amount) ? String(amount) : amount.toFixed(2);
  const symbols = {
    USD: "$",
    CAD: "$",
    EUR: "€",
  };

  if (symbols[currency]) {
    return `${symbols[currency]}${formattedAmount}`;
  }

  return `${formattedAmount} ${currency}`;
}

export default function PlayButton({ userHasAccess, onPlay, onBuy, onSubscribe, disabled, isBuying, purchasesEnabled = true, price }) {
  const handle = (fn) => () => {
    if (typeof fn === "function") fn();
  };
  const formattedPrice = formatPrice(price);

  if (userHasAccess) {
    return (
      <button
        type="button"
        className="rounded-full bg-pink-500 px-6 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-white transition hover:bg-pink-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-pink-300 disabled:opacity-60"
        onClick={handle(onPlay)}
        disabled={disabled}
      >
        Play
      </button>
    );
  }

  return (
    <div className="flex flex-wrap gap-3">
      <button
        type="button"
        className="rounded-full bg-sky-300 px-6 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-slate-950 shadow-lg shadow-sky-950/20 transition hover:bg-cyan-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-sky-200 disabled:opacity-60"
        onClick={handle(onSubscribe)}
        disabled={disabled}
      >
        Subscribe
      </button>
      <button
        type="button"
        className="rounded-full bg-emerald-500 px-6 py-2 text-sm font-semibold uppercase tracking-[0.2em] text-white transition hover:bg-emerald-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-300 disabled:opacity-60"
        onClick={handle(onBuy)}
        disabled={disabled || isBuying || !purchasesEnabled}
      >
        {!purchasesEnabled
          ? "Admin activation"
          : isBuying
            ? "Opening..."
            : `Buy${formattedPrice ? ` (${formattedPrice})` : ""}`}
      </button>
    </div>
  );
}
